// Ajuste da folha de preço e do período do pôster A3 — rodam na prévia da tela.
// ⚠️ CÓPIA IDÊNTICA de backend/src/services/posterPdf.js (lá elas rodam dentro
// do Chrome que gera o PDF). Mudou lá, muda aqui — senão a prévia mente.

/* eslint-disable no-mixed-operators */
export function arrumarFolhaPoster(folha) {
  const H = folha.clientHeight, W = folha.clientWidth;
  if (!H || !W) return;
  const q = (s) => folha.querySelector(s);
  const nome = q('.p-nome'), rs = q('.p-rs'), int = q('.p-int'), cent = q('.p-cent'), av = q('.p-avista');
  if (!int) return;
  const DIG = [0.103, 0.760], RS = [0.058, 0.879], VISTA = [0.089, 0.770];
  const CENTRO = 0.537;     // centro do bloco do preço, em fração da largura
  const LMAX = 0.84;        // largura máxima do bloco (caixas, com o respiro das letras); depois disso encosta na curva
  const F0 = 0.6638;        // número do exemplo: algarismo com 50% da altura da folha
  const TOPO_MIN = 0.3843;  // topo dos algarismos com nome de 1 linha
  const BASE_MAX = 0.905;   // pé dos algarismos mais baixo antes de encostar no contorno
  const R = 0.2289, C = 0.2823, A = 0.0871;   // R$, centavos e "à vista" em fração do número
  const G1 = -0.013, G2 = 0.031;              // respiro R$→número e número→centavos (fração do número)
  const tam = (F) => {
    int.style.fontSize = F + 'em'; rs.style.fontSize = (R * F) + 'em';
    cent.style.fontSize = (C * F) + 'em'; av.style.fontSize = (A * F) + 'em';
  };
  const larguraBloco = (F) => (rs.offsetWidth + int.offsetWidth + Math.max(cent.offsetWidth, av.offsetWidth)) / W
    + (G1 + G2) * F * H / W;

  let F = F0;
  tam(F);
  const l = larguraBloco(F);
  if (l > LMAX) { F = F * LMAX / l; tam(F); }
  // Nome de 2 linhas empurra o preço pra baixo; se não couber até a base máxima, encolhe.
  const fimNome = nome ? (nome.offsetTop + nome.offsetHeight) / H : 0;
  const topoDig = Math.max(TOPO_MIN, fimNome);
  if (topoDig + DIG[1] * F > BASE_MAX) { F = Math.max(0.2, (BASE_MAX - topoDig) / DIG[1]); tam(F); }
  folha.dataset.numero = F.toFixed(4);

  // Horizontal: R$ | número | centavos com "à vista" embaixo, centrado em CENTRO.
  const px = (v) => (v / W * 100) + '%';
  const x0 = CENTRO * W - larguraBloco(F) * W / 2;
  const xInt = x0 + rs.offsetWidth + G1 * F * H;
  const xCent = xInt + int.offsetWidth + G2 * F * H;
  rs.style.left = px(x0);
  int.style.left = px(xInt);
  cent.style.left = px(xCent);
  av.style.left = px(xCent + (cent.offsetWidth - av.offsetWidth) / 2);

  // Vertical: cada peça posicionada pelo topo da TINTA (não da caixa).
  const topo = (el, tinta, f, m) => { el.style.top = ((tinta - m[0] * f) * 100) + '%'; };
  topo(int, topoDig, F, DIG);
  const fR = R * F, meioDig = topoDig + DIG[1] * F / 2;
  topo(rs, meioDig - 0.029 * F - RS[1] * fR / 2, fR, RS);    // R$ centrado no número, um tico acima
  const fC = C * F, topoCent = topoDig + 0.0939 * F;
  topo(cent, topoCent, fC, DIG);
  topo(av, topoCent + DIG[1] * fC + 0.1073 * F, A * F, VISTA);

  // Fita do "De:": valor comprido passava da ponta da folha (e da página, com a
  // folha encostada na borda). Encolhe até caber dentro da folha.
  const de = q('.p-de');
  if (de) {
    de.style.fontSize = '';
    const fim = (de.offsetLeft + de.offsetWidth) / W, ini = de.offsetLeft / W;
    if (fim > 0.98) de.style.fontSize = (parseFloat(getComputedStyle(de).fontSize) / H * (0.98 - ini) / (fim - ini)) + 'em';
  }
}

export function arrumarPeriodo(span) {
  const k = 0.775;
  const pai = span.parentElement;
  if (!pai || !pai.clientWidth) return;
  const m = (-(1 - k) / 2 * span.offsetWidth) / pai.clientWidth * 100 + '%';
  span.style.marginLeft = m; span.style.marginRight = m;
}

export function limitarFolha(f, { prop, mostrarDe, comPeriodo }) {
  const PROPORCAO_PAGINA = 420 / 297;
  const w = Math.min(95, Math.max(15, Number(f.w) || 49.2));
  const h = w / prop / PROPORCAO_PAGINA;               // altura da folha em % da altura da página
  const yMin = mostrarDe ? 0.15 * h : 0;               // a fita fica 13% da folha acima dela
  const yMax = Math.max(yMin, (comPeriodo ? 92.8 : 100) - h);   // o período começa em ~93%
  const x = Math.min(100 - w, Math.max(0, Number(f.x) || 0));
  const y = Math.min(yMax, Math.max(yMin, Number(f.y) || 0));
  return { w, x, y };
}

// Período do story do Instagram: solto em qualquer lugar (não ocupa a largura
// toda como no pôster), então a margem que devolve o espaço do scaleX vai em em.
// ⚠️ CÓPIA IDÊNTICA de backend/src/services/storyPng.js.
export function arrumarPeriodoSolto(span) {
  const k = 0.775;
  const fs = parseFloat(getComputedStyle(span).fontSize);
  if (!fs || !span.offsetWidth) return;
  const m = (-(1 - k) / 2 * span.offsetWidth / fs) + 'em';
  span.style.marginLeft = m; span.style.marginRight = m;
}
